(() => {
  const selector = 'p[data-delay]:not(.notFadeIn), h1[data-delay]:not(.notFadeIn), h2[data-delay]:not(.notFadeIn), h3[data-delay]:not(.notFadeIn), span[data-delay]:not(.notFadeIn), div[data-delay]:not(.notFadeIn), a[data-delay]:not(.notFadeIn), li[data-delay]:not(.notFadeIn), button[data-delay]:not(.notFadeIn), .fadeIn';
  const pending = new Map();
  const observed = new WeakSet();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const reveal = element => {
    clearTimeout(pending.get(element));
    pending.delete(element);
    if (element.isConnected) element.classList.add('active-fade-in');
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const delay = Number(entry.target.dataset.delay) || 0;
      if (reduced.matches || delay <= 0) reveal(entry.target);
      else pending.set(entry.target, setTimeout(() => reveal(entry.target), delay));
    });
  }) : null;
  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach(element => {
      if (element.classList.contains('active-fade-in') || observed.has(element)) return;
      observed.add(element);
      if (reduced.matches || !observer) reveal(element);
      else observer.observe(element);
    });
  };
  reduced.addEventListener('change', () => {
    if (!reduced.matches) return;
    observer?.disconnect();
    document.querySelectorAll(selector).forEach(reveal);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(element => {
      observer?.unobserve(element);
      clearTimeout(pending.get(element));
      pending.delete(element);
      observed.delete(element);
    });
  });
})();
